import { createSelector } from 'reselect'
import { emptyArray } from 'utils'

export const getListItems = createSelector(
  state => state.search.stores,
  state => state.search.selectedStores,
  state => state.search.showSelectedOnly,
  (stores, selectedStores, showSelectedOnly) => {
    if (showSelectedOnly) {
      return selectedStores.sort((storeA, storeB) => storeB.revenueCurrent - storeA.revenueCurrent)
    }

    const storesToAppend = selectedStores.filter(selectedStore => !stores.some(store => store.storeId === selectedStore.storeId))
    if (storesToAppend.length === 0) {
      return stores
    }

    return [...stores, { isHeader: true, titleKey: 'search.selectedItems' }, ...storesToAppend]
  },
)

export const getSelectedIndices = createSelector(
  getListItems,
  state => state.search.selectedStores,
  state => state.search.showSelectedOnly,
  (allListItems, selectedStores, showSelectedOnly) => {
    if (showSelectedOnly) {
      return emptyArray
    }

    return allListItems
      .map((store, index) => (selectedStores.some(selectedStore => selectedStore.storeId === store.storeId) ? index : null))
      .filter(selectedItemIndex => selectedItemIndex || selectedItemIndex === 0)
  },
)

export const getDetails = state => state.search.details

export const getSearchInputValue = state => state.search.searchInputValue

export const isTyping = state => state.search.typing

export const isOpen = state => state.search.isOpen
